import BoxView from './BoxView';

export default BoxView;
